module.exports = __webpack_public_path__ + "static/tonezone-black-929523636686792428c40903dc6230df.png";